import React, { useState, useEffect } from "react";
import axios from "axios";

const EditPassword = ({ currentUser }) => {
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    // ✅ define function inside useEffect
    const fetchUser = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/users/filter", {
          params: {
            firstName: currentUser.firstName,
            role: currentUser.role,
            empCode: currentUser.empCode,
            center: currentUser.center,
          },
        });
        setUser(res.data);
      } catch (err) {
        console.error("❌ Error fetching user:", err);
      }
    };

    fetchUser(); // ✅ call it
  }, [currentUser]); // depend on currentUser (so refetch if user changes)

  const handleUpdatePassword = async () => {
    if (!newPassword) {
      alert("⚠️ Please enter a new password");
      return;
    }
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/users/${user._id}/password`, {
        password: newPassword,
      });
      alert("✅ Password updated successfully");
      setNewPassword("");
    } catch (err) {
      console.error("❌ Error updating password:", err);
    }
  };

  if (!user) {
    return <p style={{ textAlign: "center" }}>Loading user data...</p>;
  }

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>🔑 Edit Password</h2>

      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>👤 User Info</h3>

        <div style={{ marginBottom: "10px" }}>
          <strong>First Name:</strong> {user.firstName}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Last Name:</strong> {user.lastName}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Pseudo Name:</strong> {user.pseudoName}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Employee Code:</strong> {user.empCode}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Role:</strong> {user.role}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Center:</strong> {user.center}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>TL Name:</strong> {user.tlName}
        </div>
        <div style={{ marginBottom: "10px" }}>
          <strong>Dialer ID:</strong> {user.dialerId}
        </div>

        <div style={{ margin: "20px 0" }}>
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <button
          onClick={handleUpdatePassword}
          style={{
            background: "#2a9d8f",
            color: "white",
            padding: "10px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            width: "100%",
          }}
        >
          💾 Update Password
        </button>
      </div>
    </div>
  );
};

export default EditPassword;
